import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import Colors from '../constants/Colors';
import CS from '../constants/Styles';
import TextInputContainer from '../components/TextInputContainer';
import * as rtApi from '../components/Api';
// import * as Location from 'expo-location';

const LocationPicker = ({ ...props }) => {
  const [locationValue, setLocationValue] = React.useState('');
  const [locationSuggestions, setLocationSuggestions] = React.useState([]);
  const [locationLoading, setLocationLoading] = React.useState(false);
  const [showLocationSuggestionOverlay, setShowLocationSuggestionOverlay] = React.useState(false);
  const [locationIsSet, setLocationIsSet] = React.useState(false);

  // const ac = new AbortController();

  React.useEffect(() => {
    // return () => ac.abort();
    return () => rtApi.cancel();
  }, []);

  // React.useEffect(() => {
  //   if(props.initialSearch){
  //     console.log('props.initialSearch: ', props.initialSearch);
  //     locationChange(props.initialSearch);
  //   }
  // }, [props.initialSearch])

  const initialSearch = () => {
    console.log('initial Serach', props.streetId, props.locations);
    let i = '?street_id=' + props.streetId;
    let e = '';
    props.locations.forEach((l) => {
      e += '&existing_locations[]=' + l.id;
    });
    console.log('search/city?search_term=' + i + e);
    setLocationLoading(true);
    rtApi.cancel();
    // fetch(api.base + 'search/city?search_term=' + a + i + e, { signal: ac.signal })
    rtApi.get('search/city' + i + e)
      // .then(res => res.json())
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        console.log('data', data);
        setLocationSuggestions(data.nearby);
        // setLocationSuggestions(data.nearby.concat(data.locations));
        setLocationLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLocationLoading(false);
        setLocationSuggestions([]);
      });
  };

  const locationChange = (a) => {
    console.log('locationChange', a, props.streetId, props.locations);
    setLocationValue(a);
    if (a && a.trim().length < 3) { return; }
    let i = '';
    if (props.streetId) {
      i = '&street_id=' + props.streetId;
    }
    let e = '';
    props.locations.forEach((l) => {
      e += '&existing_locations[]=' + l.id;
    });
    console.log('search/city?search_term=' + a + i + e);
    setLocationLoading(true);
    // fetch(api.base + 'search/city?search_term=' + a + i + e, { signal: ac.signal })
    rtApi.get('search/city?search_term=' + a + i + e)
      // .then(res => res.json())
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        console.log('data', data);
        setLocationSuggestions(data.locations.concat(data.nearby));
        // setLocationSuggestions(data.nearby.concat(data.locations));
        setLocationLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLocationLoading(false);
        setLocationSuggestions([]);
      });
  };

  const toggleLocationSuggestionOverlay = async () => {
    console.log('toggleLocationSuggestionOverlay: ', props.initialSearch);
    setShowLocationSuggestionOverlay(prevState => {
      // if (!prevState) {
      //   props.setAddress(null);
      //   props.setStreetId(null);
      // }
      if (prevState) {
        // close
        blurInput();
        setLocationSuggestions([]);
        afterClose();
      } else {
        // open
        if (props.setScrollEnabled) { props.setScrollEnabled(false); }
        if (props.streetId) {
          initialSearch();
        }
      }
      return !prevState;
    })
  };
  const selectLocation = (location) => {
    console.log('selectLocation', location, props.locations);
    if (verifyLocation(location)) {
      props.setLocations([...props.locations, location]);
      setLocationSuggestions([]);
      setShowLocationSuggestionOverlay(false);
      props.setIsInvalid();
      blurInput();
      console.log('props.afterSelectLocation', props.afterSelectLocation);
      if (props.afterSelectLocation && typeof props.afterSelectLocation === 'function') {
        props.afterSelectLocation();
      }
      // props.setScrollEnabled(true);
      setLocationValue('');
    }
  };
  const afterClose = () => {
    if (props.afterSelectLocation && typeof props.afterSelectLocation === 'function') {
      props.afterSelectLocation();
    }
  }
  const verifyLocation = (location) => {
    let l = props.locations.filter((loc) => {
      return location.id === loc.id;
    });
    return l.length === 0;
  }

  const calcOffsetHeight = () => {
    return {
      paddingTop: props.offsetTop ? props.offsetTop : 0,
    }
  }

  const blurInput = () => {
    setLocationIsSet(true);
    setTimeout(() => {
      setLocationIsSet(false);
    }, 0);
  }

  return (
    <View>
      <TextInputContainer
        iconName={props.iconName ? props.iconName : null}
        placeholder={props.placeholder}
        textContentType='fullStreetAddress'
        onFocus={() => toggleLocationSuggestionOverlay()}
        value={locationValue}
        inputRef={props.inputRef}
        isInvalid={props.isInvalid}
        autoCompleteType='off'
        // textContentType="fullStreetAddress"
        onChangeText={(t) => locationChange(t)}
        returnKeyType='done'
        spellCheck={false}
        autoCorrect={false}
        editable={!locationIsSet}
        // inputContainerStyle={props.outerInputContainerStyle}
        // inputContainerStyle={{ marginBottom: 0 }}
      />
      {locationSuggestions.length >= 1 &&
        <View style={styles.locationSuggestions}>
          {locationSuggestions.map((l, i) => (
            <TouchableOpacity onPress={() => selectLocation(l)} key={i} style={[styles.locationSuggestion, (i + 1 === locationSuggestions.length) ? styles.locationSuggestionNoBorder : styles.locationSuggestionBorder]}>
              <Text style={[CS.lightText, CS.smallText]}>{l.city + ', ' + l.state}</Text>
            </TouchableOpacity>
          ))}
        </View>
      }
    </View>
  );
}

const styles = StyleSheet.create({
  locationContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    padding: 10,
    borderRadius: 10,
    zIndex: 10,
    // flex: 1,
    // backgroundColor: 'red'
  },
  suggestionsCloseButton: {
    marginBottom: 10,
  },
  locationSuggestions: {
    // position: 'absolute',
    // top: 49,
    // left: 0,
    width: '100%',
    borderColor: Colors.lightBlue,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 10,
    // paddingBottom: 10,
    backgroundColor: Colors.textInputBackground,
    marginTop: -20,
    marginBottom: 20,
  },
  locationSuggestion: {
    padding: 10,
    borderColor: Colors.lightBlue,
  },
  locationSuggestionBorder: {
    borderBottomWidth: 1,
  },
  locationSuggestionNoBorder: {
    borderBottomWidth: 0,
  },
});

export default LocationPicker;